"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createResponsePayload = exports.createRequestPayload = exports.createNotificationPayload = exports.isResultPayload = exports.isErrorPayload = exports.isNotificationPayload = exports.decodeMessage = exports.encodeMessage = void 0;
const msgpack_1 = require("@msgpack/msgpack");
function encodeMessage(message) {
    return (0, msgpack_1.encode)(message);
}
exports.encodeMessage = encodeMessage;
function decodeMessage(blob) {
    return (0, msgpack_1.decode)(blob);
}
exports.decodeMessage = decodeMessage;
function isNotificationPayload(payload) {
    return !("id" in payload) && "params" in payload;
}
exports.isNotificationPayload = isNotificationPayload;
function isErrorPayload(payload) {
    return "error" in payload;
}
exports.isErrorPayload = isErrorPayload;
function isResultPayload(payload) {
    return "result" in payload;
}
exports.isResultPayload = isResultPayload;
function createNotificationPayload(payload) {
    return encodeMessage(payload);
}
exports.createNotificationPayload = createNotificationPayload;
function createRequestPayload(payload) {
    return encodeMessage(payload);
}
exports.createRequestPayload = createRequestPayload;
function createResponsePayload(payload) {
    return encodeMessage(payload);
}
exports.createResponsePayload = createResponsePayload;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWVzc2FnZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9tZXNzYWdlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLDhDQUcwQjtBQStCMUIsU0FBZ0IsYUFBYSxDQUFDLE9BQVk7SUFDeEMsT0FBTyxJQUFBLGdCQUFhLEVBQUMsT0FBTyxDQUFDLENBQUM7QUFDaEMsQ0FBQztBQUZELHNDQUVDO0FBRUQsU0FBZ0IsYUFBYSxDQUFDLElBQWdCO0lBQzVDLE9BQU8sSUFBQSxnQkFBYSxFQUFDLElBQUksQ0FBQyxDQUFDO0FBQzdCLENBQUM7QUFGRCxzQ0FFQztBQUVELFNBQWdCLHFCQUFxQixDQUNuQyxPQUFZO0lBRVosT0FBTyxDQUFDLENBQUMsSUFBSSxJQUFJLE9BQU8sQ0FBQyxJQUFJLFFBQVEsSUFBSSxPQUFPLENBQUM7QUFDbkQsQ0FBQztBQUpELHNEQUlDO0FBRUQsU0FBZ0IsY0FBYyxDQUFDLE9BQVk7SUFDekMsT0FBTyxPQUFPLElBQUksT0FBTyxDQUFDO0FBQzVCLENBQUM7QUFGRCx3Q0FFQztBQUVELFNBQWdCLGVBQWUsQ0FDN0IsT0FBWTtJQUVaLE9BQU8sUUFBUSxJQUFJLE9BQU8sQ0FBQztBQUM3QixDQUFDO0FBSkQsMENBSUM7QUFFRCxTQUFnQix5QkFBeUIsQ0FDdkMsT0FBbUM7SUFFbkMsT0FBTyxhQUFhLENBQUMsT0FBTyxDQUFDLENBQUM7QUFDaEMsQ0FBQztBQUpELDhEQUlDO0FBRUQsU0FBZ0Isb0JBQW9CLENBQ2xDLE9BQThCO0lBRTlCLE9BQU8sYUFBYSxDQUFDLE9BQU8sQ0FBQyxDQUFDO0FBQ2hDLENBQUM7QUFKRCxvREFJQztBQUVELFNBQWdCLHFCQUFxQixDQUNuQyxPQUFxRDtJQUVyRCxPQUFPLGFBQWEsQ0FBQyxPQUFPLENBQUMsQ0FBQztBQUNoQyxDQUFDO0FBSkQsc0RBSUMifQ==